import useBackHandler from '../hooks/useBackHandler';
import React, { useRef } from 'react';
import { Dialog as MuiDialog } from '@mui/material';

// MUI keeps dialogs mounted for their exit animation. Preserve the last open
// content so a parent's state reset cannot appear in the fading dialog.
export default function StableDialog({ open, children, onBack, dismissDisabled = false, ...props }) {
    useBackHandler(open, () => { if (!dismissDisabled) (onBack || props.onClose)?.(null, 'backButton'); }, 1300);
    const lastOpenView = useRef({ children, props });
    if (open) lastOpenView.current = { children, props };
    const displayed = open ? { children, props } : lastOpenView.current;
    return <MuiDialog {...displayed.props} disableScrollLock onClose={(...args) => { if (!dismissDisabled) props.onClose?.(...args); }} open={open} sx={[displayed.props.sx, { pointerEvents: open ? 'auto' : 'none' }]}>
        {displayed.children}
    </MuiDialog>;
}
